// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__SfiVp","logo":"Navbar_logo__cuakK","active":"Navbar_active__HNsMb","badge":"Navbar_badge__56rjw"};